import { createSelector } from 'reselect';

import { currentlyEmployedSelector, isPartTimeCourseSelector } from '../../../reducers/selectors';

const currentlyEmployedAndPartTimeSelector = createSelector(
  currentlyEmployedSelector,
  isPartTimeCourseSelector,
  (currentlyEmployed, isPartTimeCourse) => {
    if (currentlyEmployed) {
      return isPartTimeCourse;
    }

    return undefined;
  },
);

export default currentlyEmployedAndPartTimeSelector;
